var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-management',{ref:"baseListManagement",attrs:{"configData":_vm.configData},on:{"update:configData":function($event){_vm.configData=$event},"update:config-data":function($event){_vm.configData=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }